import React, { useState, useEffect } from "react";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { initializeApp } from "firebase/app";
import styled from "styled-components";
import { firebaseConfig } from "../../../middlewares/firebase";
import file from '../../../assets/File.png';
// import plus2 from '../../../assets/plus2.png';

const FileInput = styled.input`
  display: none;  //tira o botão escolher arquivo
`;

const FileLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ::before {
    content: url("assets/image.png");
    /* content: ${({file})}; */
  }
`;

const Button = styled.button`
  display: flex;
  width: 2.2vw;
  height: 2.2vw;
  border: 0 none;
  border-radius: 0.5vw;
  background: #1C70BB;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  font-family: 'Rubik';
  font-size: 1.5vw;
  font-weight: 500;
  cursor: pointer;
  :hover{
    background: #054f91;
  }

  @media screen and (max-width: 480px) {
    width: 15px;
    height: 15px;
    /* border-radius: 2px; */
  }
`;

const BtnText = styled.h4`
  font-family: 'Rubik';
  font-size: 1.5vw;
  font-weight: 500;
  color: #fff;
  /* line-height: 0%; */

  @media screen and (max-width: 480px) {
    font-size: 12px;
    text-align: center;
    line-height: 0%;
  }
`;

const Message = styled.span`
  font-family: 'Rubik';
  font-size: 14px;
  font-weight: 500;
  color: #67cf12;
`;

// const Img = styled.img`
//   width: 65%;

//   @media screen and (max-width: 480px) {
//     width: 40%;
//   }
// `;

const Image = styled.img`
  width: 2.7vw; 

  @media screen and (max-width: 480px) {
    width: 20px;
  }
`;

const storage = getStorage(initializeApp(firebaseConfig));

function UploadArq({name, arqSRC, onArqUpload}: { name: string, arqSRC?: string, onArqUpload: (ArqUrl: string) => void}) {
  const [image, setImage] = useState<File>();
  const [imageUrl, setImageUrl] = useState<string>(arqSRC || '');
  const [arqvSRC, setArqvSRC] = useState<string | undefined>(arqSRC);
  const [uploadStatus, setUploadStatus] = useState<string>();
  // const [message, setMessage] = useState<Array<string>>([]);
  // const handleFileChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {

  useEffect(() => {
    setArqvSRC(arqSRC);
  }, [arqSRC])
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const f = event.target.files[0]
      setImage(f);
      setArqvSRC(URL.createObjectURL(f));
    }
  }

  const handleUpload = async () => {
    if (image) {
      try {
        const storageRef = ref(storage, `Web/arquivos/${image.name}`);
          await
        uploadBytes(storageRef, image);
          const url = await
        getDownloadURL(storageRef);
          setImageUrl(url);
          onArqUpload(url);
          setUploadStatus('Arquivo carregado com sucesso!');
      }catch (error) {
        if (error instanceof Error) {
        setUploadStatus(`Falha ao carregar arquivo: ${error.message}`);
        } else {
          setUploadStatus('Falha ao carregar arquivo');
        }
      }
    }
  }

  return (
      <div style={{display: "flex", flexDirection: "column-reverse", alignItems: "center", justifyContent: "center"}}>
          <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
              <input name={name} type="text" value={imageUrl} hidden/>
            <FileLabel 
            >
            <Image src={file} alt="" />
              <FileInput 
               type="file" onChange={handleFileChange} />
            </FileLabel>
            {/* <div> */}
            <Button type="button" onClick={handleUpload}>
              <BtnText>+</BtnText>
            </Button>
          </div>
          { arqvSRC }
          <Message>{uploadStatus}</Message>
          {/* {imageUrl && <img src={imageUrl} alt="uploaded" />} */}
      </div>
  );
};
export default UploadArq;